/** True si ambos campos tienen valor y el enlace es el mismo (sin espacios, sin mayúsculas). */
export function areDocumentLinksDuplicate(doc1: string, doc2: string): boolean {
  const a = doc1.trim()
  const b = doc2.trim()
  if (!a || !b) return false
  return a.toLowerCase() === b.toLowerCase()
}

export const DUPLICATE_DOCUMENT_LINKS_MESSAGE =
  'El documento 1 y el documento 2 no pueden tener el mismo enlace.'
